import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  TextField as MuiTextField,
  Autocomplete as MuiAutocomplete,
} from "@mui/material";
import { Search as MuiSearchIcon } from "@mui/icons-material";
import { useBudgetingContext } from "app/services/budgetingContext";
import { getDepartmentByMatch } from "app/services/budgetingService";
import { useAlerts } from "common";

const searchIconStyles = {
  "& .MuiAutocomplete-popupIndicatorOpen": {
    // Stop MUI from rotating the icon when the popup is open
    rotate: "180deg",
  },
};

export const DepartmentNameControl = (props) => {
  const { t } = useTranslation();
  const { setAlert, clearAlert } = useAlerts();
  const { departmentValue, updateDepartmentValue } = useBudgetingContext();

  const [loading, setLoading] = useState(false);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  return (
    <MuiAutocomplete
      id="departmentName"
      loading={loading}
      options={departmentOptions || []}
      getOptionLabel={(option) => option.displayText || ""}
      value={departmentValue}
      fullWidth
      autoHighlight
      handleHomeEndKeys
      disableClearable
      popupIcon={<MuiSearchIcon />}
      sx={searchIconStyles}
      onChange={(e, value) => {
        updateDepartmentValue(value);
      }}
      onInputChange={(e, inputValue) => {
        if (!inputValue || inputValue.trim() === "") {
          setDepartmentOptions([]);
          return;
        }
        getDepartmentByMatch(
          inputValue,
          setDepartmentOptions,
          setLoading,
          setAlert,
          clearAlert,
        );
      }}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          label={`${t("Budgeting.mainView.departmentNameDropdown.title")}`}
        />
      )}
    />
  );
};
